import { getUuid } from '@flatbiz/utils';

/* eslint-disable @typescript-eslint/no-unsafe-argument */
export function getOwnerWindow(node?: HTMLElement | null) {
  return node instanceof Element ? getOwnerDocument(node).defaultView ?? window : window;
}

export function getOwnerDocument(node?: HTMLElement | null) {
  return node instanceof Element ? node.ownerDocument ?? document : document;
}

export function contains(parent: HTMLElement, child: HTMLElement) {
  return parent === child || parent.contains(child);
}

export const isWindow = (obj) => {
  return obj != null && obj === obj.window;
};

export const getStyles = (elem) => {
  // Support: IE<=11+, Firefox<=30+ (#15098, #14150)
  // IE throws on elements created in popups
  // FF meanwhile throws on frame elements through 'defaultView.getComputedStyle'
  if (elem.ownerDocument.defaultView.opener) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return elem.ownerDocument.defaultView.getComputedStyle(elem, '');
  }
  return window.getComputedStyle(elem, '');
};

export const accessProperty = (elem, propName: string): number => {
  elem = elem || window;

  if (isWindow(elem)) {
    return elem.document.documentElement['client' + propName] as number;
  }

  // Get document width or height
  if (elem.nodeType === 9) {
    const doc = elem.documentElement;
    return Math.max(
      elem.body[`scroll${propName}`],
      doc['scroll' + propName],
      elem.body['offset' + propName],
      doc['offset' + propName],
      doc['client' + propName],
    );
  }

  // Get width or height on the element, requesting but not forcing parseFloat
  return parseInt(getStyles(elem)[propName.toLowerCase()], 10) || 0;
};

export const getElemWidth = (elem?: HTMLElement): number => {
  return accessProperty(elem, 'Width');
};

export const getElemHeight = (elem?: HTMLElement): number => {
  return accessProperty(elem, 'Height');
};

export interface BodyAppendDivElementProps {
  divElement: HTMLDivElement;
  elementId: string;
}

export const bodyAppendDivElement = (): BodyAppendDivElementProps => {
  const div = document.createElement('div');
  const id = `id_${Date.now()}`;
  div.setAttribute('id', id);
  document.body.append(div);
  return {
    divElement: div,
    elementId: id,
  };
};

export const createDivElement = () => {
  const div = document.createElement('div');
  const id = `id_${getUuid()}`;
  div.setAttribute('id', id);
  return div;
};

// 删除body的子节点
export const removeBodyChild = (element: string) => {
  try {
    document.body.removeChild(document.querySelector(element) as Node);
  } catch (error) {
    //
  }
};

/**
 * 获取React dom 根节点
 * @returns
 */
export const getRectRootNodeElement = () => {
  return document.querySelector('#app') as HTMLDivElement;
};
